import {ROOT_API} from '../../../config/config'
import url from '../../../utils/url'
import permissionMixin from '../../../mixins/permission-mixin'
import {PERMS} from '../../../config/permissions'
import {IMPORT_STATUS_CODE_PROCESSING, IMPORT_STATUS_CODE_LOADED, IMPORT_STATUS_CODE_CANCELED} from '../utils/types'
import saveFile from '../../../utils/saveFile'

export default {
  mixins: [permissionMixin],
  data () {
    this.lastUpdateAt = 0
    return {
      dragInProgress: false,
      showList: false,
      enableFileUpload: true,
      queue: []
    }
  },
  computed: {
    scrollUpdateStreamName () {
      return 'import.excel.scroll'
    },
    IMPORT_STATUS_CODE_CANCELED () {
      return IMPORT_STATUS_CODE_CANCELED
    },
    IMPORT_STATUS_CODE_LOADED () {
      return IMPORT_STATUS_CODE_LOADED
    },
    IMPORT_STATUS_CODE_PROCESSING () {
      return IMPORT_STATUS_CODE_PROCESSING
    },
    UPDATE_DELAY () {
      return 1000
    },
    supportedFormat () {
      return []
    },
    items () {
      return this.$store.getters.readUrlEndpoint(this.getEndpoint(this.$route, this.getType(this.$route)))
    },
    queueEmpty () {
      return this.queue.length === 0
    },
    templates () {
      return this.$store.getters.readUrlEndpoint(this.getTemplateEndpoint({}, this.getType(this.$route)))
    },
    currentUser () {
      return this.$store.getters.userData
    }
  },
  created () {
    this.setBreadcrumbs()
  },
  mounted () {
    this.startOrStopUpdate()
  },
  destroyed () {
    this.stopUpdate()
  },
  methods: {
    userCanDeleteFile (item) {
      if (item.importStatus && item.importStatus.code == IMPORT_STATUS_CODE_CANCELED) {
        return false
      }
      if (this.userCanDelete === false) {
        return false
      }
      if (item && item.user && this.currentUser && item.user.id == this.currentUser.id) {
        return true
      }
      return false
    },
    setBreadcrumbs () {
      try {
        let prevRoute = url.encode(url.getPrevRoute(this.$route))
        let {location} = this.$router.resolve(prevRoute)
        let matchedRoute = this.$router.match(location)
        let links = []
        if (matchedRoute.matched) {
          for (let i = 0; i < matchedRoute.matched.length; i++) {
            let link = matchedRoute.matched[i]
            if (link.meta && link.meta.title) {
              links.push(link)
            }
          }
        } else {
          links.push({name: matchedRoute.name, meta: matchedRoute.meta})
        }
        links.push({name: this.$route.name, query: this.$route.query, meta: this.$route.meta})
        this.$store.commit('breadcrumbs', {
          name: this.$route.name,
          links: links
        })
      } catch (e) {
        console.error(e)
        this.$store.commit('breadcrumbs', {
          name: this.$route.name,
          links: null
        })
      }
    },
    onDragStart () {
      this.dragInProgress = true
    },
    onDragEnd () {
      this.dragInProgress = false
    },
    onFileDrop (e) {
      this.addFile(e)
    },
    addFile (e) {
      this.onDragEnd()
      console.log(e)
      e.preventDefault()
      e.stopPropagation()
      e.value = null
      let errorMsg = ''
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        errorMsg += 'Не выбраны файлы'
        return
      }
      if (!this.queueEmpty) {
        errorMsg += 'Дождитесь окончания загрузки недавно загруженных файлов'
      }
      if (!this.userHavePermissionEx(PERMS.CREATE)) {
        errorMsg += 'Нет прав на загрузку'
      }
      if (errorMsg.length < 1) {
        for (let f of files) {
          if (!this.checkFileExt(f)) {
            errorMsg += 'Неверный формат у файла ' + f.name + ', этот файл не будет загружен '
          } else {
            this.uploadFile(f)
          }
        }
        // hack for enable double load same file
        // drop old file input and create new
        this.enableFileUpload = false
        setTimeout(() => {
          this.enableFileUpload = true
        }, 150)
      }
      if (errorMsg.length > 0) {
        this.$e.errorBox(errorMsg)
      }
    },
    addToQueue (name) {
      this.queue.push(name)
      this.$swal({
        title: this.queue.length > 1 ? 'Загрузка файлов' : 'Загрузка файла',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        onOpen: () => {
          this.$swal.showLoading()
        }
      })
    },
    removeFromQueue (name) {
      let findedIndex = this.queue.findIndex(v => v === name)
      if (findedIndex > -1) {
        this.queue.splice(findedIndex, 1)
      }
      if (this.queueEmpty) {
        this.$swal.close()
      }
    },
    uploadFile (file, index = 0) {
      let fileName = file.name || index
      console.log('upload file')
      this.addToQueue(fileName)
      this.$store.dispatch('uploadFile', {
        url: this.getUploadUrl(),
        data: {
          type: this.getType(this.$route),
          upload: file
        }
      }).then(r => {
        console.log(r)
        this.removeFromQueue(fileName)
        this.addFileToServerQueue(r.import_file_id).then(queueResponse => {
          console.log(queueResponse)
        }).catch(er => {
          console.error(er)
        })
        if (this.queueEmpty) {
          this.$bar.start()
        }
        setTimeout(() => {
          this.reFetchData()
        }, 300)
        setTimeout(() => {
          this.reFetchData().then(() => {
            if (this.queueEmpty) {
              this.$bar.finish()
            }
            this.scrollTableToTop()
          }).catch(e => {
            console.error(e)
            if (this.queueEmpty) {
              this.$bar.finish()
            }
          })
        }, 2000)
        /* this.addFileToServerQueue(r.import_file_id).then(queueResponse => {
          this.reFetchData().then(() => {
            this.scrollTableToTop()
          })
        }).catch(er => {
          this.$e.errorBox(er)
        }) */
      }).catch(e => {
        this.removeFromQueue(fileName)
        this.reFetchData()
        this.$e.errorBox(e)
      })
    },
    scrollTableToTop () {
      console.log('scrollTableToTop')
      this.$emitter.emit(this.scrollUpdateStreamName, {
        action: 'scroll',
        coords: {}
      })
    },
    reFetchData () {
      if (!this.queueEmpty) {
        return Promise.resolve(1)
      }
      let {asyncData} = this.$options
      return asyncData({
        store: this.$store,
        route: this.$route,
        fromRoute: this.$route,
        methods: this,
        isAutoUpdate: true
      }).then(r => {
        this.startOrStopUpdate()
        return r
      }).catch(e => {
        return e
      })
    },
    startOrStopUpdate () {
      let needUpdates = false
      if (this.items && this.items.data) {
        this.items.data.forEach(v => {
          if (v && v.importStatus && v.importStatus.code && v.importStatus.code === IMPORT_STATUS_CODE_PROCESSING) {
            needUpdates = true
          }
        })
      }
      if (needUpdates === false) {
        this.stopUpdate()
      } else {
        this.startUpdate()
      }
    },
    startUpdate () {
      if (this.updateInterval) {
        clearTimeout(this.updateInterval)
      }

      this.updateInterval = setTimeout(() => {
        this.reFetchData()
      }, this.UPDATE_DELAY)
    },
    stopUpdate () {
      if (this.updateInterval) {
        clearTimeout(this.updateInterval)
      }
      this.updateInterval = null
    },
    addFileToServerQueue (id) {
      return this.$store.dispatch('createModel', {
        url: this.getServerQueueEndpoint(id),
        data: {
          id
        }
      })
    },
    checkFileExt (file) {
      let isSupportedExt = false
      this.supportedFormat.forEach(ext => {
        if (file.name && file.name.toString().toLowerCase().endsWith('.' + ext)) {
          isSupportedExt = true
        }
      })
      return isSupportedExt
    },
    deleteItem (item) {
      this.$e.confirmBox(
        'Все занесенные записи будут удалены',
        'Отменить загрузку?'
      ).then(() => {
        console.log(item)
        this.$bar.start()
        this.$store.dispatch('deleteModel', {
          url: this.getDeleteUrl(item.id, item.importType.code, item)
        }).then(() => {
          this.$bar.finish()
          this.reFetchData()
        }).catch(er => {
          this.$bar.finish()
          this.$e.errorBox(er)
        })
      })
    },
    downloadFile (item) {
      const endpoint = `${ROOT_API}${item.file.url}`
      this.download(endpoint, item.file.name)
    },
    downloadErrorFile (item) {
      const endpoint = `${ROOT_API}${item.errorFile.url}`
      this.download(endpoint, item.errorFile.name)
    },
    download (endpoint, fileName) {
      this.$bar.start()
      return this.$store.dispatch('downloadFile', {endpoint}).then(r => {
        saveFile({blob: r.request.response, fileName})
        this.$bar.finish()
      }).catch(e => {
        console.error(e)
        this.$bar.finish()
        this.$e.errorBox(e)
      })
    },
    getTemplate (template, code) {
      console.log(code, template)
      this.showList = false
      const endpoint = this.getDownloadTemplateEndpoint(code)
      this.download(endpoint, `${template.name || 'template'}.${template.ext || 'xlsx'}`)
    }
  },
  asyncData ({store, route, fromRoute, methods, isAutoUpdate = false}) {
    let promises = []

    promises.push(store.dispatch('updateUrlEndpoint', {
      endpoint: methods.getEndpoint(route, methods.getType(route))
    }))
    if (isAutoUpdate === false) {
      promises.push(store.dispatch('updateUrlEndpoint', {
        endpoint: methods.getTemplateEndpoint(route, methods.getType(route))
      }))
    }

    return Promise.all(promises)
  }
}
